var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.imageLink + _vm.image}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }